import React, { useState, useEffect } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { deleteAgeGroup, getAgeGroupList, updateAgeGroup, uploadAgeGroupImage } from "../adminSlice";
import { AppDispatch } from "../../../store";
import { useDispatch } from "react-redux";
import { validateIsFileImageType } from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const EditDeleteAgeGroup = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [ageGroupList, setAgeGroupList] = useState<any>([]);
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [ageGrpName, setAgeGrpName] = useState<any>("");
  const [frontImage, setFrontImage] = useState<any>("");
  const [frontImageUpload, setFrontImageUpload] = useState<any>("");
  const [ageGrpDesc, setAgeGrpDesc] = useState<any>("");
  const [backImage, setBackImage] = useState<any>("");
  const [backImageUpload, setBackImageUpload] = useState<any>("");
  const [seoName, setseoName] = useState<any>("");
  const [ageGrpId, setAgeGrpId] = useState<any>("");
  const [ageGrpList, setageGrpList] = useState<any>([]);
  const [order, setOrder] = useState<any>("");
  const [frontImagePreview, setFrontImagePreview] = useState<any>("");
  const [backImagePreview, setBackImagePreview] = useState<any>("");


  useEffect(() => {
    getdata();
  }, []);

  const getdata = () => {
    dispatch(
      getAgeGroupList({
        callback: (res: any) => {
          setAgeGroupList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };

  const onchangeAgeGrpName = (value: any) => {
    setAgeGrpName(value);
  };

  const onchangeOrder = (value: any) => {
    setOrder(value);
  };
  const onchangefrontImage = (value: any) => {
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      if (!mediaTypes.includes(file.type)) {
        console.error("Unsupported file type:", file.type);
        return;
      }
      reader.onloadend = () => {
        setFrontImagePreview(reader.result);
      };
      dispatch(
        uploadAgeGroupImage({
          params: file,
          callback: (res: any) => {
            if (res?.status === "success") {
              setFrontImage(res?.data?.name);
            }
          },
          errorCallback: (error: any) => { },
        })
      );
      reader.readAsDataURL(file);
    }
  };

  const onchangeAgeGrpDesc = (value: any) => {
    setAgeGrpDesc(value);
  };

  const onchangeBackImage = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setBackImagePreview(reader.result);
      };
      dispatch(
        uploadAgeGroupImage({
          params: file,
          callback: (res: any) => {
            if (res?.status === "success") {
              setBackImage(res?.data?.name);
            }
          },
          errorCallback: (error: any) => { },
        })
      );
      reader.readAsDataURL(file);
    }
  };

  const onchangeSeoName = (value: any) => {
    setseoName(value);
  };

  const handleEdit = (value: any) => {
    setageGrpList(value);
    setAgeGrpId(value._id);
    setAgeGrpName(value.name);
    setAgeGrpDesc(value.ageGroup);
    setFrontImage(value.frontImage);
    setBackImage(value.backImage);
    setseoName(value.seoName);
    setOrder(value.order);
    setisEditMode(true);
  };
  const handleDelete = (value: any) => {
    dispatch(
      deleteAgeGroup({
        id: value._id,
        callback: (res: any) => {
          dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
          getdata();
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const handleUpdate = (e: any) => {
    e.preventDefault();
    const postData: any = {};
    if (ageGrpList?.name !== ageGrpName) {
      postData["name"] = ageGrpName;
    }
    if (ageGrpList?.ageGroup !== ageGrpDesc) {
      postData["ageGroup"] = ageGrpDesc;
    }
    if (ageGrpList?.frontImage !== frontImage) {
      postData["frontImage"] = frontImage;
    }
    if (ageGrpList?.backImage !== backImage) {
      postData["backImage"] = backImage;
    }
    if (ageGrpList?.seoName !== seoName) {
      postData["seoName"] = seoName;
    }
    if (ageGrpList?.order !== order) {
      postData["order"] = order;
    }
    dispatch(
      updateAgeGroup({
        id: ageGrpId,
        params: postData,
        callback: (res: any) => {
          setisEditMode(false);
          if (res?.data?.status === "success") {
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
            setageGrpList([]);
            setAgeGrpId("");
            setAgeGrpName("");
            setAgeGrpDesc("");
            setFrontImage("");
            setBackImage("");
            setFrontImagePreview("");
            setBackImagePreview("");
            setseoName("");
            setOrder("");
            setisEditMode(false);
            getdata();
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    )
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  const validations = () => {
    return (
      ageGrpName === "" ||
      ageGrpDesc === "" ||
      frontImage === "" ||
      backImage === "" ||
      seoName === "" ||
      order === ""
    );
  };

  const renderTable = () => {
    return (
      <AdminTable
        tableData={ageGroupList ? ageGroupList : []}
        pagename={"ageGroup"}
        tableHead={["S.N", "Age Group", "Name", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleUpdate}>
        <div className="row">
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Enter age group "} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter Range(0-2) "}
              setInputText={(value: any) => onchangeAgeGrpName(value)}
              value={ageGrpName}
              maxLength={5}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Enter description"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter description"}
              setInputText={(value: any) => onchangeAgeGrpDesc(value)}
              value={ageGrpDesc}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"SEO Name"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter SEO Name"}
              setInputText={(value: any) => onchangeSeoName(value)}
              value={seoName}
              maxLength={100}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"Order number"} isRequired />
            <InputField
              // key={"ex2"}
              placeholder={"Order  No."}
              setInputText={(value: any) => onchangeOrder(value)}
              value={order}
              maxLength={2}
            />
          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"front Image"} isRequired />
            <ImagePickerAndViewer
              value={frontImagePreview ? frontImagePreview : frontImage}
              handleChange={(value: any) => onchangefrontImage(value)}
              htmlFor={`photo-upload-front`}
              doctype={""} />

          </div>
          <div className="col-md-3 mb-3">
            <LabelInput labelName={"back Image"} isRequired />
            <ImagePickerAndViewer
              value={backImagePreview ? backImagePreview : backImage}
              handleChange={(value: any) => onchangeBackImage(value)}
              htmlFor={`photo-upload-back`}
              doctype={""} />
          </div>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <div className="col-2 pt-2">
            <Submitbtn name={"Submit"} disabled={validations()} />
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Age Group"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteAgeGroup;
